import React from 'react';
import { Helmet } from 'react-helmet';
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1';
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader';
import Aca1 from '../../../Componet/Academy/Aca1He';
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm';

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer';

function AcademyHe() {
    return (
        <div className="academy-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - אקדמיה והכשרות לעסקים</title>
                <meta
                    name="description"
                    content="הכשרות טכנולוגיות, סדנאות מעשיות ותוכניות onboarding לארגונים שצריכים לחזק יכולות פנימיות, לקצר זמן כניסה לתפקיד, ולשפר ביצוע בפועל."
                />
                <meta
                    name="keywords"
                    content="אקדמיה ארגונית, הכשרות טכנולוגיות, onboarding, סדנאות מקצועיות, LMS, upskilling, training for teams"
                />
                <meta property="og:title" content="EpicFinal - אקדמיה והכשרות לעסקים" />
                <meta
                    property="og:description"
                    content="הכשרות טכנולוגיות, סדנאות מעשיות ותוכניות onboarding לארגונים שצריכים לחזק יכולות פנימיות, לקצר זמן כניסה לתפקיד, ולשפר ביצוע בפועל."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/academy" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - אקדמיה והכשרות לעסקים" />
                <meta
                    name="twitter:description"
                    content="הכשרות טכנולוגיות, סדנאות מעשיות ותוכניות onboarding לארגונים שצריכים לחזק יכולות פנימיות, לקצר זמן כניסה לתפקיד, ולשפר ביצוע בפועל."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"אקדמיה והכשרות"} />
            <div className="page-content">
                <Aca1 />
                <ConsultingForm
                    language="he"
                    formId="epic-academy-form"
                    conversionSendTo="AW-11461100984/xNTjCPGatZgcELiLitkq"
                    conversionValue={1.0}
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="ספרו לנו איזה ידע או הכשרה אתם צריכים"
                    subtitle="השאירו פרטים קצרים ונחזור אליכם עם מענה מקצועי והכוונה ראשונית לתוכנית ההכשרה שלכם."
                />
                <NewsletterL1 />
            </div>
        </div>
    );
}

export default AcademyHe;

